/**
 * Created by lihanying on 2017/7/6.
 */
import React from 'react'
import { Table, Input, Button } from 'antd'
import Popconfirm from '../../../components/Popconfirm/Popconfirm2'
import ModalInfo from './modalInfo'
const Search = Input.Search

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
    }
  }

  onRowSelect = (record, index, event) => {
    this.setState({
      memberData: record,
    })
  }

  onShowModal = (record) => {
    this.setState({
      club_name: record.club_name,
      club_id: record.id,
    })
    this.props.fetchClubInfo(record.id).then((res) => {
      this.setState({ loading: false, visible: true })
    }) //俱乐部详情
    this.props.fetchWalletInfo(record.id) //钱包
  }

  handleOk = () => {
    const { clubInfo } = this.props
    let data = {
      club_id: this.state.club_id,
      password: sessionStorage.getItem('password') || '',
      official_person:
        sessionStorage.getItem('name') || clubInfo.official_person,
      contact_number:
        sessionStorage.getItem('phone') || clubInfo.contact_number,
      official_person_phone:
        sessionStorage.getItem('official_phone') ||
        clubInfo.official_person_phone,
      club_address:
        sessionStorage.getItem('club_address') || clubInfo.club_address,
      club_name: sessionStorage.getItem('club_name') || clubInfo.club_name,
    }
    this.props.fetchEditClub(data)
    this.setState({ visible: false }, () => {
      sessionStorage.removeItem('password')
      sessionStorage.removeItem('name')
      sessionStorage.removeItem('phone')
      sessionStorage.removeItem('official_phone')
      sessionStorage.removeItem('club_address')
      sessionStorage.removeItem('club_name')
    })
  }

  handleCancel = () => {
    this.setState({ visible: false }, () => {
      this.props.getClubInfo({})
    })
  }

  render() {
    const { list, clubInfo, walletInfo, walletRecord } = this.props
    const columns = [
      {
        title: '俱乐部id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '俱乐部名称',
        dataIndex: 'club_name',
        key: 'club_name',
      },
      {
        title: 'account',
        dataIndex: 'account',
        key: 'account',
      },
      {
        title: '负责人',
        dataIndex: 'official_person',
        key: 'official_person',
      },
      {
        title: '电话',
        dataIndex: 'official_person_phone',
        key: 'official_person_phone',
      },
      {
        title: '操作',
        dataIndex: 'edit',
        key: 'edit',
        render: (text, record, index) => {
          return (
            <div style={{ cursor: 'default' }}>
              <Button
                type="primary"
                style={{ marginRight: '15px' }}
                onClick={() => this.onShowModal(record)}
              >
                详情
              </Button>
              <Popconfirm
                title={`你确认要删除${record.club_name}吗?`}
                okText="确认"
                cancelText="取消"
                onConfirm={() => this.props.fetchDeleteClub(record.id)}
              >
                <Button type="primary" danger>
                  删除
                </Button>
              </Popconfirm>
            </div>
          )
        },
      },
    ]

    return (
      <div>
        <Search
          placeholder="请输入查询的俱乐部"
          style={{ width: 200, marginBottom: '1rem' }}
          onSearch={(value) => this.props.searchData(value)}
        />
        <Table
          rowKey="id"
          loading={this.state.loading}
          columns={columns}
          dataSource={list}
        />
        <ModalInfo
          {...this.state}
          clubInfo={clubInfo}
          walletInfo={walletInfo}
          walletRecord={walletRecord}
          handleOk={this.handleOk}
          handleCancel={this.handleCancel}
          fetchWalletRecord={this.props.fetchWalletRecord}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubList/component/clubList.js